export default __webpack_public_path__ + "static/media/github-Thumbnail.6011b63e.png";